import apiConfig from "./ApiURL.json";
var apiEndpoint = process.env.VUE_APP_TOKO_API || apiConfig.autonumber;
import App from "./App/App.js";

export default {
  getList(params) {
    let options = {
      cid: App.Session.getCompanyID(),
      uid: App.Session.getUserID()
    };
    options = Object.assign(options, params);
    const attributes = ["cid", "uid", "active"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/autonumber/list" + urlParams
    };
  },
  postData(data) {
    return {
      method: App.Enum.Axios.Method.Post,
      url: apiEndpoint + "/api/v1/autonumber",
      data: data
    };
  },
}